import type { PageLoad } from './$types';

export const load: PageLoad = () => {
  return {
    meta: {
      title: 'Users',
      activeNav: 'users',
      breadcrumbs: {
        activeTitle: 'Instructors',
        items: [{
          title: "Users",
          href: "/admin/users"
        }],
      },
    },
  };
};
